import { RootState } from 'handlers';

export const getCardData = ({ cardData }: RootState) => cardData;
